// extracted by mini-css-extract-plugin
export default {"button":"XNC7lz"};